import { PrefillSurveyFieldsInfo } from '../../models/survey';
import { CheckoutState } from '../../state';
import {
    getEmailToPrefill,
    getFirstNameToPrefill,
    getLastNameToPrefill,
} from '../../utils/user';
import { isTransferredOrder } from '../order';
import { shouldManageUserSavedSurveyData } from '../order/typedOrderSelectors';
import { getSurveyResponseNameValues } from './getSurveyResponseNameValues';
import { getFirstAttendeeWithSurvey } from './pureSelectors';
import { shouldPrefillFirstAttendeeBasicInfoQuestions } from './shouldPrefillFirstAttendeeBasicInfoQuestions';

export const getPrefillSurveyInfo = (
    state: CheckoutState,
): PrefillSurveyFieldsInfo => ({
    attendeeWithSurvey: getFirstAttendeeWithSurvey(state),
    emailToPrefill: getEmailToPrefill(state),
    firstNameToPrefill: getFirstNameToPrefill(state),
    isTransferredOrder: isTransferredOrder(state),
    lastNameToPrefill: getLastNameToPrefill(state),
    shouldManageUserSavedSurveyData: shouldManageUserSavedSurveyData(state),
    shouldPrefillFirstAttendeeBasicInfoQuestions:
        shouldPrefillFirstAttendeeBasicInfoQuestions(state),
    surveyResponseNameValues: getSurveyResponseNameValues(state),
});
